const CONSTANTS = {
  GET_PRIVACY_POLICIES: "GET_PRIVACY_POLICIES",
  SET_PRIVACY_POLICIES: "SET_PRIVACY_POLICIES",

};

export default CONSTANTS;
